import devStore from './development';
import prodStore from './production';

const store = process.env.NODE_ENV === 'production' ? prodStore : devStore;

export default store;
